import React from 'react';
import useOrganization from '../../hooks/use-organization';
import OrganizationMembershipDetails from './organization/details';
import MembershipDetail from './membershipDetail';

function IndexDetails() {
  const organizationInfo = useOrganization();
  return Boolean(organizationInfo?.id) ? (
    <OrganizationMembershipDetails />
  ) : (
    <MembershipDetail />
  );
}

export default IndexDetails;
